import { Controller } from "@hotwired/stimulus"
import React from 'react';
import { createRoot } from 'react-dom/client';
import ReleasesFilter from '../components/releases/ReleasesFilter';

// Connects to data-controller="categories"
export default class extends Controller {
  static values = {
    selectedCategories: Array,
    view: Object,
    project: Object,
    location: String
  }
  
  connect() {
    const root = createRoot(this.element);

    return root.render(
      <ReleasesFilter
        selectedCategories={this.selectedCategoriesValue}
        view={this.viewValue}
        project={this.projectValue}
        location={this.locationValue}
      />
    );
  }
}
